import { Email } from "@mui/icons-material"
import { Box, Button, Link, Stack, Typography } from "@mui/material"

interface TopBarProps {
  phone: boolean
}

export default function TopBar({ phone }: TopBarProps) {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        pt: 4,
        pb: 4,
        background: "rgba(7, 16, 33, 0.6)",
      }}
      width="100%"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        maxWidth="1000px"
        sx={{ pr: 4 }}
      >
        <Stack spacing={phone ? 0 : 1}>
          <Box
            component="img"
            src="/logo200x100.png"
            sx={{ ml: 3 }}
            width={phone ? 120 : 200}
          />

          {!phone && (
            <Stack>
              <Typography
                fontSize={14}
                color="rgb(230, 238, 246)"
                fontFamily="unset"
              >
                Des entrepôts plus efficaces
              </Typography>
              <Typography
                fontSize={14}
                color="rgb(230, 238, 246)"
                fontFamily="unset"
              >
                plus intelligents, plus sobres
              </Typography>
            </Stack>
          )}
        </Stack>

        <Stack alignItems={"center"} spacing={1} sx={{ mt: 1 }}>
          <Button
            variant="contained"
            sx={{
              mr: 3,
              background: "rgb(79, 150, 13)",
              color: "white",
              fontWeight: "bold",
            }}
            onClick={() =>
              window.open(
                "https://calendar.app.google/9dcR6mKhQMhb8UoU9",
                "_blank",
              )
            }
          >
            Prendre RDV
          </Button>
          <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <Link
              href="mailto:victor@wm-up.com"
              style={{ textDecoration: "none" }}
            >
              <Email />
            </Link>
            <Link
              href="tel:0651542924"
              style={{ textDecoration: "none", fontSize: 14 }}
            >
              06 51 54 29 24
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
